
import { defineComponent } from "vue";
import { mapState } from "vuex";
import MessagesVue from "@/components/GroupMessages.vue";
import GroupMembersVue from "@/components/GroupMembers.vue";
import GroupInputMessageVue from "@/components/GroupInputMessage.vue";
import AddUserVue from "@/components/AddUser.vue";

export default defineComponent({
  name: "GroupPage",
  components: {
    MessagesVue,
    GroupMembersVue,
    GroupInputMessageVue,
    AddUserVue,
  },
  computed: {
    ...mapState(["currentGroup", "loadedUsersFromGroup"]),
  },
});
